import React from "react";
import PayPerks from "../../../assets/images/new_payperks.png"
 import { useNavigate } from "react-router-dom";
const SmiPayPerks = () => {
    const navigate = useNavigate();
    const navigateToPayperks = () => {
        navigate("/PayPerks")
    }
    return(
    <div className="bg-[#C2D6C6] rounded-tl-[40px] rounded-br-[40px] w-full h-auto md:w-[859px] md:h-[402px] p-6 md:p-10 flex flex-col md:flex-row items-center md:items-start justify-between shadow-md mx-auto">
        {/* Left Section */}
        <div className="flex flex-col items-center md:items-start md:w-1/2">
            <h2 className="text-2xl md:text-3xl font-serif-pro text-[#1A3A2D] mb-4 text-center md:text-left">
                Learn and Earn<br />with PayPerks
            </h2>
            {/* Logo */}
            <div className="flex items-center mt-14 ml-[60px] md:mb-0 h-[129px] w-[191px]">
                <img src={PayPerks} alt=""></img>
            </div>
        </div>
        {/* Right Section */}
        <div className="flex flex-col items-start md:items-end md:w-1/2 mt-6 md:mt-0">
            <p className="font-[Hanken Grotesk] font-medium text-[18px] leading-[28px] tracking-normal text-[#1A3A2D] mb-6 text-center md:text-left max-w-xs">
                When you use your card or complete one of our learning modules, you can enter to win cash rewards with PayPerks.
            </p>
            <div className="flex items-center mt-14 ml-[60px] md:mb-0 h-[129px] w-[191px]">
            <button className="bg-[#00654f] text-white px-8 py-6 rounded-full font-semibold shadow hover:bg-[#17432a] transition "
            onClick={navigateToPayperks}>
                Get Started
            </button>
            </div>
        </div>
    </div>
)};
 
export default SmiPayPerks;